// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_3J7LB","Head":"Hero__Head_3MWn-","Title":"Hero__Title_2-vaS"};